import { Variants } from "motion/react";

// Desktop icons pop in one after another once the desktop mounts
export const iconVariants: Variants = {
  hidden: { opacity: 0, y: 18, scale: 0.6 },
  show: (index: number = 0) => ({
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      delay: 0.25 + index * 0.06,
      type: "spring",
      stiffness: 320,
      damping: 18,
    },
  }),
};

export const iconMotionProps = (index: number) => ({
  variants: iconVariants,
  custom: index,
  initial: "hidden",
  animate: "show",
  "data-desktop-icon": true,
});
